var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlancCybax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 525.89 279.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#drop-shadow-2);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-3, .cls-5 {\n        fill: none;\n      }\n\n      .cls-2, .cls-5 {\n        stroke-width: .75px;\n      }\n\n      .cls-2, .cls-6 {\n        stroke: #e63d11;\n      }\n\n      .cls-7, .cls-6 {\n        fill: #e63d11;\n      }\n\n      .cls-8 {\n        fill: #12120d;\n      }\n\n      .cls-9 {\n        filter: url(#outer-glow-5);\n      }\n\n      .cls-3 {\n        stroke-width: 7px;\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        stroke: #fff;\n      }\n\n      .cls-4, .cls-10 {\n        fill: #fff;\n      }\n\n      .cls-4, .cls-6 {\n        stroke-width: .5px;\n      }\n\n      .cls-11 {\n        fill: #e30613;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    x: 382.27,
    y: 156,
    width: 152.64,
    height: 136.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.67,
    dy: 5.67
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-5",
    x: 467.42,
    y: 202.25,
    width: 41.01,
    height: 31.77,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 0.17
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "384.03 158.06 384.03 170.41 384.43 170.41 403.78 170.41 403.8 152.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61,35.18c1.54-1.87,3.56-4.02,6.16-6.16,2.32-1.91,4.56-3.36,6.51-4.45h23.71c.9.59,2.21,1.5,3.68,2.74,6.19,5.22,9.14,11.13,11.13,15.24,5.63,11.6,8.44,17.4,10.62,22.26,2.28,5.11,5.67,12.48,10.1,21.38l21.4-52.89c.41-1.19,1.63-4.24,4.79-6.51,2.06-1.47,4.09-2.01,5.29-2.23h23.54c1.89.41,5.74,1.55,8.49,4.97,3.42,4.25,3.06,9.47,2.74,14.04-.19,2.69-.82,6.93-3.07,11.8l-41.1,72.78v53.76h-35.91c-.79-.27-1.96-.76-3.13-1.71-2.96-2.4-3.69-5.89-4.11-7.88-.25-1.18-.5-2.95-.34-5.14v-38.69L61,35.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M229.98,73.93c6.33,0,11.47,5.14,11.47,11.47s-5.14,11.47-11.47,11.47-11.47-5.14-11.47-11.47,5.14-11.47,11.47-11.47ZM220.09,105.56h19.77v64.06h-19.77v-64.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M316.61,160.65c-.23-.43-.44-.87-.63-1.32M317.34,161.89c-.26-.4-.5-.82-.73-1.24M357.81,163.09v-1.4h-.26c-.2.32-.41.63-.63.92M315.97,159.33c-.99-2.28-1.53-4.88-1.53-7.79,0-22.14,26.89-22.54,43.36-22.54,0-6.99-5.8-11.47-12.65-11.47-6.46,0-11.86,2.9-16.08,7.64l-10.54-10.81c7.25-6.85,17.79-10.28,28.21-10.28,23.07,0,29.26,11.73,29.26,33.08v21.79M352.93,141.65c-6.06,0-19.51.53-19.51,9.23,0,4.75,5.01,6.99,9.36,6.99,7.78,0,15.03-4.09,15.03-12v-4.22h-4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M190.63,70.51h19.77v99.65h-19.77v-99.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M384.03,157.02v-50.87h19.77v10.28h.26c4.22-7.78,9.75-11.86,18.45-11.86,2.24,0,4.75.13,6.59.66v18.06c-2.77-.79-5.54-1.32-8.44-1.32-15.03,0-16.87,8.7-16.87,21.49v9.09"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 444.73,
    cy: 116.67,
    r: 9.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M289.79,159.68v-20.67c0-7.38-.13-16.87-10.28-16.87s-11.86,8.04-11.86,16.34v31.9h-19.77v-64.06h18.98v8.7h.26c2.64-5.01,9.1-10.28,18.72-10.28,20.03,0,23.72,13.18,23.72,30.32v24.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "289.77 159.99 289.77 170.38 309.56 170.38 309.56 159.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "356.92 164.14 356.92 170.41 375.99 170.41 375.99 160.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "189.77 182.41 243.2 182.41 290.22 162.66 351.72 162.66 407.27 148.69 438.05 123.82"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M411.58,190.78c-8.03-1.88-15.81-7.1-19.97-14.23-.15,7.47,1.27,15.87,4.7,22.51,1.74,3.37,3.48,7.57,7.13,10.1-1.03,5.5-2.08,15.44,1.69,26.5,6.59,19.35,24.82,32.99,44.57,36,1.72.26,31.91,4.33,51.43-18.86,2.26-2.68,16.72-20.46,12-44.57-5.21-26.62-29.2-37.49-31.71-38.57-23.63-10.21-48.48-.28-61.85,11.94-3.65,3.34-6.24,6.65-7.98,9.19Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "508.44 202.26 508.44 202.25 499.19 202.25 487.93 213.51 487.93 222.76 499.19 234.02 508.44 234.02 492.56 218.14 508.44 202.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "476.68 234.02 487.93 222.76 492.56 218.14 487.93 213.51 476.67 202.25 467.42 202.25 483.31 218.14 467.42 234.02 476.68 234.02"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M422.3,212.55c-.28-1.99-2.18-3.5-4.37-3.5-3.95,0-5.43,3.36-5.43,6.86s1.48,6.69,5.43,6.69c2.69,0,4.2-1.85,4.53-4.48h4.25c-.45,4.98-3.89,8.18-8.79,8.18-6.19,0-9.83-4.62-9.83-10.39s3.64-10.55,9.83-10.55c4.39,0,8.09,2.58,8.62,7.19h-4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M436.45,227.64c-.87,2.32-2.24,3.27-4.98,3.27-.81,0-1.62-.06-2.44-.14v-3.28c.76.06,1.54.17,2.32.14,1.37-.14,1.82-1.57,1.37-2.72l-5.09-13.58h4.25l3.28,9.91h.06l3.16-9.91h4.11l-6.05,16.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M443.85,205.83h3.98v7.28h.06c.98-1.48,2.77-2.16,4.56-2.16,2.88,0,5.99,2.32,5.99,7.61s-3.11,7.64-5.99,7.64c-2.13,0-3.89-.64-4.76-2.24h-.06v1.85h-3.78v-19.99ZM451.07,213.95c-2.35,0-3.39,2.21-3.39,4.65s1.04,4.62,3.39,4.62,3.39-2.21,3.39-4.62-1.04-4.65-3.39-4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M460.8,215.8c.22-3.72,3.55-4.84,6.8-4.84,2.88,0,6.35.64,6.35,4.12v7.53c0,1.32.14,2.63.5,3.22h-4.03c-.14-.45-.25-.92-.28-1.4-1.26,1.32-3.11,1.79-4.87,1.79-2.74,0-4.93-1.37-4.93-4.34,0-3.28,2.46-4.06,4.93-4.4,2.44-.36,4.7-.28,4.7-1.9,0-1.71-1.18-1.96-2.57-1.96-1.51,0-2.49.62-2.63,2.18h-3.98ZM469.98,218.74c-.67.59-2.07.62-3.3.84-1.23.25-2.35.67-2.35,2.13s1.15,1.85,2.44,1.85c3.11,0,3.22-2.46,3.22-3.33v-1.48Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M408.11,231.63h2.11v.35h-1.58v.61h1.38v.34h-1.38v1.04h-.54v-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M410.6,233.12c0-.52.41-.89,1.12-.89s1.12.37,1.12.89-.41.9-1.12.9-1.12-.37-1.12-.9ZM412.35,233.12c0-.29-.19-.6-.63-.6s-.63.31-.63.6.19.6.63.6.63-.31.63-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M415.32,233.97h-.48v-.24h0c-.12.17-.39.28-.63.28-.58,0-.83-.22-.83-.67v-1.08h.49v1.04c0,.3.16.41.42.41.41,0,.54-.2.54-.46v-.99h.49v1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M415.96,232.27h.46v.33h0c.06-.18.35-.37.65-.37.11,0,.14,0,.18,0v.36c-.07,0-.14-.02-.21-.02-.33,0-.6.21-.6.58v.81h-.49v-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M417.67,232.27h.46v.25h0c.15-.18.4-.3.69-.3.48,0,.78.2.78.58v1.17h-.49v-1.07c0-.27-.15-.38-.43-.38-.33,0-.54.2-.54.45v1h-.49v-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M420.26,231.63h.49v.35h-.49v-.35ZM420.26,232.27h.49v1.7h-.49v-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M421.77,233.43c.03.22.24.3.5.3.18,0,.51-.03.49-.22-.01-.2-.37-.22-.72-.28-.36-.06-.71-.16-.71-.5,0-.37.52-.49.93-.49.45,0,.87.14.93.52h-.51c-.04-.18-.24-.23-.45-.23-.14,0-.4.03-.4.17,0,.18.36.21.72.27.36.06.72.16.72.5,0,.4-.53.55-.99.55-.56,0-.97-.19-.98-.59h.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M424.12,233.43c.03.22.24.3.5.3.18,0,.51-.03.49-.22-.01-.2-.37-.22-.72-.28-.36-.06-.71-.16-.71-.5,0-.37.52-.49.93-.49.45,0,.87.14.93.52h-.51c-.04-.18-.24-.23-.45-.23-.14,0-.4.03-.4.17,0,.18.36.21.72.27.36.06.72.16.72.5,0,.4-.53.55-.99.55-.56,0-.97-.19-.98-.59h.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M426.48,233.22c0,.27.19.5.6.5.28,0,.45-.1.54-.28h.46c-.11.37-.52.58-1,.58-.69,0-1.08-.37-1.08-.89,0-.48.41-.9,1.07-.9.7,0,1.13.48,1.05.99h-1.63ZM427.62,232.97c-.02-.24-.23-.45-.56-.45s-.57.2-.58.45h1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M430.55,233.97h-.48v-.24h0c-.12.17-.39.28-.63.28-.58,0-.83-.22-.83-.67v-1.08h.49v1.04c0,.3.16.41.42.41.41,0,.54-.2.54-.46v-.99h.49v1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M431.19,232.27h.46v.33h0c.06-.18.35-.37.65-.37.11,0,.14,0,.18,0v.36c-.07,0-.14-.02-.21-.02-.33,0-.6.21-.6.58v.81h-.49v-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M436.23,233.97h-.46v-.23h0c-.13.19-.41.28-.69.28-.7,0-1.04-.4-1.04-.91,0-.61.48-.88.96-.88.28,0,.59.08.74.27h0v-.87h.49v2.35ZM435.13,233.72c.44,0,.62-.31.62-.6,0-.37-.24-.6-.61-.6-.46,0-.62.31-.62.62s.19.58.61.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M437.26,233.22c0,.27.19.5.6.5.28,0,.45-.1.54-.28h.46c-.11.37-.52.58-1,.58-.69,0-1.08-.37-1.08-.89,0-.48.41-.9,1.07-.9.7,0,1.13.48,1.05.99h-1.63ZM438.4,232.97c-.02-.24-.23-.45-.56-.45s-.57.2-.58.45h1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M439.76,233.43c.03.22.24.3.5.3.18,0,.51-.03.49-.22-.01-.2-.37-.22-.72-.28-.36-.06-.71-.16-.71-.5,0-.37.52-.49.93-.49.45,0,.87.14.93.52h-.51c-.04-.18-.24-.23-.45-.23-.14,0-.4.03-.4.17,0,.18.36.21.72.27.36.06.72.16.72.5,0,.4-.53.55-.99.55-.56,0-.97-.19-.98-.59h.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M443.07,231.63h.49v.35h-.49v-.35ZM443.07,232.27h.49v1.7h-.49v-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M444.21,232.27h.46v.25h0c.15-.18.4-.3.69-.3.48,0,.78.2.78.58v1.17h-.49v-1.07c0-.27-.15-.38-.43-.38-.33,0-.54.2-.54.45v1h-.49v-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M448.88,233.97h-.46v-.23h0c-.13.19-.41.28-.69.28-.7,0-1.04-.4-1.04-.91,0-.61.48-.88.96-.88.28,0,.59.08.74.27h0v-.87h.49v2.35ZM447.79,233.72c.44,0,.62-.31.62-.6,0-.37-.24-.6-.61-.6-.46,0-.62.31-.62.62s.19.58.61.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M451.48,233.97h-.48v-.24h0c-.12.17-.39.28-.63.28-.58,0-.83-.22-.83-.67v-1.08h.49v1.04c0,.3.16.41.42.41.41,0,.54-.2.54-.46v-.99h.49v1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M452.49,233.43c.03.22.24.3.5.3.18,0,.51-.03.49-.22-.01-.2-.37-.22-.72-.28-.36-.06-.71-.16-.71-.5,0-.37.52-.49.93-.49.45,0,.87.14.93.52h-.51c-.04-.18-.24-.23-.45-.23-.14,0-.4.03-.4.17,0,.18.36.21.72.27.36.06.72.16.72.5,0,.4-.53.55-.99.55-.56,0-.97-.19-.98-.59h.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M454.24,232.27h.37v-.51h.49v.51h.44v.28h-.44v.91c0,.15.02.23.24.23.07,0,.14,0,.21-.01v.29c-.11,0-.21.02-.32.02-.51,0-.6-.15-.61-.43v-1h-.37v-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M456.02,232.27h.46v.33h0c.06-.18.35-.37.65-.37.11,0,.14,0,.18,0v.36c-.07,0-.14-.02-.21-.02-.33,0-.6.21-.6.58v.81h-.49v-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M457.66,231.63h.49v.35h-.49v-.35ZM457.66,232.27h.49v1.7h-.49v-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M459.19,233.22c0,.27.19.5.6.5.28,0,.45-.1.54-.28h.46c-.11.37-.52.58-1,.58-.69,0-1.08-.37-1.08-.89,0-.48.41-.9,1.07-.9.7,0,1.13.48,1.05.99h-1.63ZM460.33,232.97c-.02-.24-.23-.45-.56-.45s-.57.2-.58.45h1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M461.33,231.63h.49v2.35h-.49v-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M462.84,233.43c.03.22.24.3.5.3.18,0,.51-.03.49-.22-.01-.2-.37-.22-.72-.28-.36-.06-.71-.16-.71-.5,0-.37.52-.49.93-.49.45,0,.87.14.93.52h-.51c-.04-.18-.24-.23-.45-.23-.14,0-.4.03-.4.17,0,.18.36.21.72.27.36.06.72.16.72.5,0,.4-.53.55-.99.55-.56,0-.97-.19-.98-.59h.49Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlancCybax);
export default __webpack_public_path__ + "static/media/Blanc-Cybax.de5602b118d8018c65c39b36a1263bba.svg";
export { ForwardRef as ReactComponent };